import React, { useEffect } from "react";
import { FruitifyContainer } from "../../../shared-components/Containers";
import { useParams } from "react-router-dom";
import { withPageTracking } from "../../../services/postHog";
import { QuizSubmission } from "../components/QuizSubmission";
import { useQuizGroup } from "../hooks/useQuizGroup";
import GeneralLoading from "../../../shared-components/Loading";

const StudentQuizSubmissionBase = ({
  quizGroupId,
  student = null,
  teacherView = false,
}) => {
  const { quizGroup, loading, fetchQuizGroup } = useQuizGroup(quizGroupId);

  useEffect(() => {
    if (quizGroupId && !Object.keys(quizGroup).length) {
      fetchQuizGroup({ initialLoad: true });
    }
  }, [quizGroupId]);

  if (loading) {
    return <GeneralLoading />;
  }

  return (
    <FruitifyContainer p={2}>
      <QuizSubmission
        identifier={student}
        quizGroup={quizGroup}
        setIdentifier={() => {}}
        teacherView={teacherView}
      />
    </FruitifyContainer>
  );
};

const TeacherQuizResponse = () => {
  const { quizGroupId, studentId } = useParams();
  return (
    <StudentQuizSubmissionBase
      quizGroupId={quizGroupId}
      student={{ id: studentId }}
      teacherView
    />
  );
};

const StudentQuizSubmission = () => {
  const { quizGroupId } = useParams();
  return <StudentQuizSubmissionBase quizGroupId={quizGroupId} />;
};

export const TeacherQuizResponseView = withPageTracking(TeacherQuizResponse, {
  feature: "quiz-response-view-teacher",
});

export const StudentQuizSubmissionView = withPageTracking(
  StudentQuizSubmission,
  { feature: "quiz-response-view-student" },
);
